<template>


<div class="">
    <div class="page-loader-wrapper loading-container" style="display: none;">
        <div class="loading">
            <img src="/static/images/loading.gif">
        </div>
    </div>
    <div class="">
        <section class="container-fluid middle-section territory-page">
            <div class="row mt-4">

                <div class="col-md-4">
                    <multiselect
                        name="marketSegment"
                        id="marketSegment"
                        v-model="pinApply"
                        @input="inputPinFilter"
                        label="key"
                        :options="pinFilter"
                        :multiple=false
                        :taggable="true"
                        track-by="key"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :hideSelected=false
                        placeholder="Market Segment">
                    </multiselect>
                </div>

                <!--div class="col-md-4 text-center">
                <div class="row mt-4">
                <template v-for="(data, index) in DutyMarketShare">
                  <div class="col-md-12">
                  <label class="ml-5"> {{ data.name }}:  {{ data.market_share }} %</label>
                  </div>
                </template>
                </div>
                </div-->



              <div class="col-md-8">
                <vue-table-dynamic :params="params"></vue-table-dynamic>
              </div>


              <!--template v-for="(data, index) in manufacturerDetail">
                <label class="ml-5"> {{ data.name }}:  {{ data.market_share }} %</label>
              </template-->
            </div>

            <div class="row">
                <div class="col-md-10">
                    <ul class="mapping-filter">
                        <li>
                          <multiselect
                              name="marketSegment"
                              id="marketSegment"
                              v-model="marketSegment"
                              label="name"
                              :options="marketSegmentArr"
                              :multiple=false
                              :taggable="true"
                              track-by="id"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              placeholder="Market Segment">
                          </multiselect>

                        </li>
                        <li>
                          <multiselect
                              name="manufacturer"
                              id="manufacturer"
                              v-model="manufacturer"
                              label="name"
                              :options="manufacturerArr"
                              :multiple=true
                              :taggable="true"
                              track-by="id"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              placeholder="Manufacturer">

                              <template slot="selection" slot-scope="{ values, search }">
                                <span class="multiselect__single" v-if="values.length">{{ values.length }} Manufacturer selected
                                </span>
                              </template>
                          </multiselect>

                        </li>
                        <li>
                          <multiselect
                              name="pma"
                              id="pma"
                              v-model="pma"
                              label="name"
                              :options="pmaArr"
                              :multiple=false
                              :taggable="true"
                              track-by="id"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              @input="changedValuePMA"
                              placeholder="PMA">
                          </multiselect>
                        </li>
                        <li style="min-width:200px">
                          <multiselect
                              name="lga"
                              id="lga"
                              v-model="lga"
                              label="name"
                              :options="lgaArr"
                              :multiple=true
                              :taggable="true"
                              track-by="id"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              :close-on-select="false"
                              :option-height="50"
                              placeholder="LGA">

                              <template slot="selection" slot-scope="{ values, search }">
                                <span class="multiselect__single" v-if="values.length">{{ values.length }} LGA selected
                                </span>
                              </template>
                          </multiselect>

                        </li>
                        <li>
                          <multiselect
                              name="fromMonth"
                              id="fromMonth"
                              v-model="fromMonth"
                              label="name"
                              :options="fromMonthArr"
                              :multiple=false
                              :taggable="true"
                              track-by="id"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              placeholder="From Month">
                          </multiselect>
                        </li>
                        <li>

                          <multiselect
                              name="fromYear"
                              id="fromYear"
                              v-model="fromYear"
                              label="year"
                              :options="fromYearArr"
                              :multiple=false
                              :taggable="true"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel=""
                              :hideSelected=false
                              placeholder="From Year"
                              :disabled="fromMonth=='' || fromMonth==null">
                          </multiselect>

                        </li>
                        <li>

                          <multiselect
                                name="toMonth"
                                id="toMonth"
                                v-model="toMonth"
                                label="name"
                                :options="fromMonthArr"
                                :multiple=false
                                :taggable="true"
                                track-by="id"
                                selectLabel=""
                                deselectLabel=""
                                selectedLabel=""
                                :hideSelected=false
                                placeholder="To Month">
                          </multiselect>

                        </li>
                        <li>

                          <multiselect
                                name="toYear"
                                id="toYear"
                                v-model="toYear"
                                label="year"
                                :options="toYearArr"
                                :multiple=false
                                :taggable="true"
                                selectLabel=""
                                deselectLabel=""
                                selectedLabel=""
                                :hideSelected=false
                                placeholder="To Year"
                                :disabled="toMonth==''">
                          </multiselect>

                        </li>
                    </ul>
                </div>
                <div class="col-md-2">
                    <div class="postal-code">
                        <!--input type="text" v-model="postcode" @keypress="isValidPostcode($event)" placeholder="postcode1,postcode2,postcode3..." /-->
                        <button class="search-btn" v-on:click="searchResult">Search</button> <!-- @click="getSalesDataByFilter('')" -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9 map-container">
                     <gmap :gmapmarkers="mapmarkers" :soldUnit="soldUnit"></gmap>
                    <!-- <heatmap></heatmap>-->
                </div>

            <div class="col-md-3">


                <table class="table table-bordered table-striped">

                  <thead>
                      <tr class="table-primary" style="text-align: center;">
                          <th>Total</th>
                          <th>
                            <div class="page-name" v-if="total != 0">{{ total }}</div>
                          </th>
                      </tr>
                  </thead>
                </table>

                <div class="table-wrapper-scroll-y" style="height: 65vh;overflow: auto;">
                  <table class="table table-bordered table-striped mb-0">
                      <thead>
                          <tr class="table-primary" style="text-align: center;">
                              <th>Manufacturer</th>
                              <th>Market Share</th>
                              <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if="statistics && statistics.length > 0">
                          <tr v-for="(data, index) in statistics" :key="index">
                              <td style="text-align: center;">
                                  <span>{{titleCase(data.name)}}</span>
                              </td>
                              <td style="text-align: right;">
                                  <span>{{parseFloat((data.count/total)*100).toFixed(2)}}%</span>
                              </td>

                              <td style="text-align: right;">
                                  <span>{{ data.count }}</span>
                              </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td colspan="3" align="center">No data!!</td>
                          </tr>
                        </template>
                      </tbody>
                  </table>
                </div>

                <!--template v-for="(data, index) in statistics">

                <div class="row">
                  <div class="page-name">{{ data.name }} : {{ data.count }}</div>
                  <div class="page-name ml-5"> Market Share : {{ parseFloat((data.count/total)*100).toFixed(2) }} %</div>
                </div>




                </template-->
            </div>



            </div>
        </section>
    </div>
</div>
  <!-- <div class="mt-5">
    <gmap :gmapmarkers="mapmarkers"></gmap>
  </div> -->
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
var app = '';

import Vue from "vue";

import GoogleMap from '../GoogleMap'
// import GoogleHeatMap from '../GoogleHeatMap'
import {getsalesdata, getselectionData, getLGAfromPMA, getSearchResult} from '../../config'
import {getsalesbyvehicletypeandpostcode} from '../../config'
import axios from 'axios'

import Multiselect from 'vue-multiselect';
import VueTableDynamic from 'vue-table-dynamic'


export default {
  components: {
    'gmap': GoogleMap,
    VueTableDynamic,
    // 'heatmap': GoogleHeatMap,
    Multiselect,
  },
  data() {
    return {
      params: {
        data: [
        ],
        border:true,
        header: 'row',
        stripe: true,
        columnWidth: [{column: 0, width: 200}],
      },
      total : 0,
      marketSegment: '',
      marketSegmentArr: [],
      soldUnit: 0,

      manufacturer: '',
      manufacturerArr: [],

      pma: '',
      pmaArr: [],

      lga: '',
      lgaArr: [],

      fromMonth: '',
      fromMonthArr: [
        {
          name: 'January',
          id: 1,
        },
        {
          name: 'February',
          id: 2,
        },
        {
          name: 'March',
          id: 3,
        },
        {
          name: 'April',
          id: 4,
        },
        {
          name: 'May',
          id: 5,
        },
        {
          name: 'Jun',
          id: 6,
        },
        {
          name: 'July',
          id: 7,
        },
        {
          name: 'August',
          id: 8,
        },
        {
          name: 'September',
          id: 9,
        },
        {
          name: 'October',
          id: 10,
        },
        {
          name: 'November',
          id: 11,
        },
        {
          name: 'December',
          id: 12,
        },
      ],

      fromYear: '',
      fromYearArr: [],

      toMonth: '',
      toMonthArr: [],

      toYear: '',
      toYearArr: [],

      mapmarkers:[],
      postcode: "",
      isVanActive:false,
      isFusoActive:false,
      isBenzActive:false,
      isFreightlinerActive:false,
      isHeavyDutyActive:false,
      isMediumDutyActive:false,
      isLightDutyActive:false,
      statistics: [],


      DutyMarketShare: [],
      manufacturerDetail: [],
      lgaStatistics: [],

      pinFilter: [],
      pinApply: ''
    }
  },
  created: function () {
  },
  beforeMount: function () {
    app = this;
    app.checkLocalStorage();
  },
  mounted: function () {
    $(".loading-container").show();


    app.searchResult();
    app.loadSelectionData();
  },
  methods: {
    inputPinFilter:function (value, id) {
      console.log("VAL ==", value);
      if(value != null) {

        app.mapmarkers = []

        app.mapmarkers =  value.value;
        app.soldUnit =  value.count;

      }
    },
    titleCase(str) {
        if (str == null) {
            return;
        } else {
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    searchResult:function() {
      if(app.fromMonth != "" && app.fromMonth != null ) {
        if(app.fromYear == '' ||  app.fromYear == null) {
          alert("Please select From Year");
          return;

        }
      }

      if(app.fromYear != "" && app.fromYear != null ) {
        if(app.fromMonth == '' ||  app.fromMonth == null) {
          alert("Please select From Month");
          return;
        }
      }
      if(app.toMonth != "" && app.toMonth != null) {
        if(app.toYear == '' ||  app.toYear == null) {
          alert("Please select To Year");
          return;
        }
      }

      if(app.toYear != "" && app.toYear != null ) {
        if(app.toMonth == '' ||  app.toMonth == null) {
          alert("Please select To Month");
          return;
        }
      }

      if(app.fromYear != '' &&  app.fromYear != null && app.toYear != '' && app.toYear != null) {
        if(app.fromYear.year > app.toYear.year) {
          alert("From date never higher than to date");
          return;
        } else if(app.fromYear.year == app.toYear.year) {
          if(app.fromMonth.id > app.toMonth.id) {
            alert("From date never higher than to date");
            return;
          }
        }
      }

      var config = {
            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
        };

        var data = {
        }

        if(app.marketSegment != '' && app.marketSegment != null) {
          data.market_segment =   app.marketSegment.id;
        }



        if(app.manufacturer != '' && app.manufacturer != null ) {
          var ids = []
          app.manufacturer.forEach(function(val){
              ids.push(val.id)
          });
          data.manufacture = ids;
        }


        if(app.pma != '' && app.pma != null) {
          data.pma = app.pma.id;
        }
        if(app.lga != '' && app.lga != null)  {
          var ids = []
          app.lga.forEach(function(val){
              ids.push(val.id)
          });
          data.lga =  ids
        }
        if (app.fromMonth != '' && app.fromMonth != null)  {
          data.from_month = app.fromMonth.id;
        }

        if (app.fromYear != '' && app.fromYear != null ) {
          data.from_year = app.fromYear.year;
        }
        if (app.toMonth != '' && app.toMonth != null ) {
          data.to_month = app.toMonth.id;
        }
        if( app.toYear != '' && app.toYear != null)  {
          data.to_year =app.toYear.year;
        }

        $(".loading-container").show();

        axios.post(getSearchResult, data, config)
                .then(function (response) {
                if(response.data.code=='204') {
                    setTimeout(function() { $(".loading-container").hide(); },1000);
                    alert(response.data.message);
                } else if (response.data.code == '200') {
                    if(response.data.content) {
                      app.statistics = [];
                      app.statistics = response.data.statistics;
                      app.total = response.data.total;

                      // app.DutyMarketShare = response.data.segment_count;
                      app.manufacturerDetail = response.data.manufacturer_count;
                      app.params.data = response.data.manufacturer_count;
                      // app.lgaStatistics = response.data.lga_statistics;

                      // app.mapmarkers = []

                      // app.mapmarkers =  response.data.content;
                      app.mapmarkers = [];
                      app.pinFilter = [];
                      app.pinFilter =  response.data.content;
                      if(app.pinFilter.length > 0) {
                        app.pinApply = app.pinFilter[0];
                        app.mapmarkers = []
                        app.mapmarkers =  app.pinApply.value;
                        app.soldUnit =  app.pinApply.count;
                      }
                      // response.data.content.forEach(element => {

                      //   var marketShare;
                      //   var lga_name;
                      //   var filterIndex = app.lgaStatistics.findIndex(obj => obj.id == element.lga_id);
                      //   if(filterIndex != -1) {

                      //      marketShare = parseFloat((app.lgaStatistics[filterIndex].count/app.total)*100).toFixed(2);
                      //      lga_name = app.lgaStatistics[filterIndex].name;

                      //   }

                      //   var pinImg = "";

                      //   if(marketShare > 10) {
                      //     pinImg = '../../static/images/green_pin.png';
                      //   } else {
                      //     pinImg = '../../static/images/red_pin.png';
                      //   }
                      //   app.mapmarkers.push({
                      //     lat: parseFloat(element.latitude),
                      //     lng: parseFloat(element.longitude),
                      //     position: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude)},
                      //     name: element.manufacturer,
                      //     iconUrl: pinImg,    // if you want to show different as per the condition.
                      //     option: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude),
                      //       'postcode': element.postcode, 'name': element.manufacturer, 'purchased_uint': "", "market_share": marketShare,
                      //       "lga_name" : lga_name },
                      //   });
                      // });

                      console.log("data load");

                      setTimeout(function() { $(".loading-container").hide(); },100);
                    }
                } else {
                    // console.log("fail");
                }

                // $(".loading-container").hide();
        })
        .catch(function (err) {
            //app.$refs.fileglexportdata.value = '';
            // $(".loading-container").hide();
            if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                self.$router.push("/");
                //EventBus.$emit("logged-in", true, "", "");
            }
            setTimeout(function() { $(".loading-container").hide(); },2000);
        });

    },
    changedValuePMA: function () {
        app.lga = '';
        if(app.pma != null ) {

          var config = {
            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
          };
          axios.get(getLGAfromPMA + app.pma.id, config)
                  .then(function (response) {
                  if(response.data.code=='204') {
                      setTimeout(function() { $(".loading-container").hide(); },1000);
                      alert(response.data.message);
                  } else if (response.data.code == '200') {
                      if(response.data.content) {
                        app.lga = response.data.content;
                      }
                  }
                  setTimeout(function() { $(".loading-container").hide(); },2000);
                  // $(".loading-container").hide();
          })
          .catch(function (err) {
              //app.$refs.fileglexportdata.value = '';
              // $(".loading-container").hide();
              if (err.response.status == 401) {
                  //clear previous data
                  localStorage.removeItem("user_obj");
                  localStorage.removeItem("api_token");
                  self.$router.push("/");
                  //EventBus.$emit("logged-in", true, "", "");
              }
              setTimeout(function() { $(".loading-container").hide(); },2000);
          });

        }


    },
    loadSelectionData: function () {

       var config = {
            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
        };
        axios.get(getselectionData, config)
                .then(function (response) {
                if(response.data.code=='204') {
                    setTimeout(function() { $(".loading-container").hide(); },1000);
                    alert(response.data.message);
                } else if (response.data.code == '200') {
                    if(response.data.content) {
                        app.manufacturerArr = response.data.content.manufactures;

                        app.lgaArr = response.data.content.lga;

                        app.fromYearArr = response.data.content.years;
                        app.toYearArr = response.data.content.years;
                        app.pmaArr = response.data.content.pma;
                        app.marketSegmentArr = response.data.content.market_segment;
                    }
                } else {
                    // console.log("fail");
                }
                // setTimeout(function() { $(".loading-container").hide(); },2000);
                // $(".loading-container").hide();
        })
        .catch(function (err) {
            //app.$refs.fileglexportdata.value = '';
            // $(".loading-container").hide();
            if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                self.$router.push("/");
                //EventBus.$emit("logged-in", true, "", "");
            }
            setTimeout(function() { $(".loading-container").hide(); },2000);
        });

    },
    checkLocalStorage : function () {
        var token = app.$route.query.token;
        token = (token === null || typeof (token) === "undefined" || token == '') ? '' : token;
        app.redirectUrl = app.$route.query.redirect_url;
        app.redirectUrl = (app.redirectUrl === null || typeof (app.redirectUrl) === "undefined" || app.redirectUrl == '') ? '' : app.redirectUrl;
        if (token != "") {
            app.getUserFromToken(token, "login");
        } else {
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var apiToken = localStorage.getItem("api_token");
                apiToken = (apiToken === null || typeof (apiToken) === "undefined" || apiToken == '') ? '' : apiToken;
                if (apiToken != '') {
                    if (app.redirectUrl != '') {
                        openDirectLink(app.redirectUrl);
                    }
                    if(token != '') {
                      app.$router.push('/sales');
                    }
                }else {
                    localStorage.clear();
                    let $url=process.env.SSO_URL + "/login?redirect=" + process.env.APP_URL + "&slug=" + process.env.APP_SLUG;
                    openDirectLink($url);
                }
            } else {
                localStorage.clear();
                let $url=process.env.SSO_URL + "/login?redirect=" + process.env.APP_URL + "&slug=" + process.env.APP_SLUG;
                openDirectLink($url);
            }
        }
    },
    getsalesdata() {
       var config = {
            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
        };
        axios.get(getsalesdata, config)
                .then(function (response) {
                if(response.data.code=='204') {
                    setTimeout(function() { $(".loading-container").hide(); },1000);
                    alert(response.data.message);
                } else if (response.data.code == '200') {
                    if(response.data.content) {
                        response.data.content.forEach(element => {
                            app.mapmarkers.push({
                              position: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude)},
                              name: element.name,
                              icon: "",    // if you want to show different as per the condition.
                              option: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude), 'postcode': element.postcode, 'name': element.name, 'purchased_uint': element.purchased_uint },
                            });
                        });
                    }
                } else {
                    // console.log("fail");
                }
                setTimeout(function() { $(".loading-container").hide(); },2000);
                // $(".loading-container").hide();
        })
        .catch(function (err) {
            //app.$refs.fileglexportdata.value = '';
            // $(".loading-container").hide();
            if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                self.$router.push("/");
                //EventBus.$emit("logged-in", true, "", "");
            }
            setTimeout(function() { $(".loading-container").hide(); },2000);
        });
    },
    isValidPostcode: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(evt.target.value.length >=100) {
        alert('Only 100 characters allowed');
        evt.preventDefault();
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getSalesDataByFilter: function(vehicleType) {
        $(".loading-container").show();
        const dataparams = new URLSearchParams();
        let requestVehicleType = "";
        switch(vehicleType) {
          case 'Vans':
            app.isVanActive = !app.isVanActive;
            break;
          case 'Fuso':
            app.isFusoActive = !app.isFusoActive;
            break;
          case 'Benz':
            app.isBenzActive = !app.isBenzActive;
            break;
          case 'Freightliner':
            app.isFreightlinerActive = !app.isFreightlinerActive;
            break;
          case 'Heavy Duty':
            app.isHeavyDutyActive = !app.isHeavyDutyActive;
            break;
          case 'Medium Duty':
            app.isMediumDutyActive = !app.isMediumDutyActive;
            break;
          case 'Light Duty':
            app.isLightDutyActive = !app.isLightDutyActive;
            break;
        }
        if(app.isVanActive) {
          requestVehicleType = requestVehicleType + "," + "Vans";
        }
        if(app.isFusoActive) {
          requestVehicleType = requestVehicleType + "," + "Fuso";
        }
        if(app.isBenzActive) {
          requestVehicleType = requestVehicleType + "," + "Benz";
        }
        if(app.isFreightlinerActive) {
          requestVehicleType = requestVehicleType + "," + "Freightliner";
        }
        if(app.isHeavyDutyActive) {
          requestVehicleType = requestVehicleType + "," + "Heavy Duty";
        }
        if(app.isMediumDutyActive) {
          requestVehicleType = requestVehicleType + "," + "Medium Duty";
        }
        if(app.isLightDutyActive) {
          requestVehicleType = requestVehicleType + "," + "Light Duty";
        }
        if(requestVehicleType) {
          dataparams.append('vehicletype', requestVehicleType);
        }
        if(app.postcode) {
          dataparams.append('postcode', app.postcode);
        }
        var config = {
            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            params: dataparams
        };
        axios.get(getsalesbyvehicletypeandpostcode, config)
            .then(function (response) {
            if(response.data.code=='204') {
                setTimeout(function() { $(".loading-container").hide(); },1000);
                alert(response.data.message);
            } else if (response.data.code == '200') {
              app.mapmarkers.splice(0);
                if(response.data.content) {
                    response.data.content.forEach(element => {
                        app.mapmarkers.push({
                          position: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude)},
                          name: element.name,
                          icon: "",    // if you want to show different as per the condition.
                          option: {'lat': parseFloat(element.latitude), 'lng': parseFloat(element.longitude), 'postcode': element.postcode, 'name': element.name, 'purchased_uint': element.purchased_uint },
                        });
                    });
                }
            } else {
                // console.log("fail");
            }
            setTimeout(function() { $(".loading-container").hide(); },2000);
        })
        .catch(function (err) {
          if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                self.$router.push("/");
                //EventBus.$emit("logged-in", true, "", "");
            }
            setTimeout(function() { $(".loading-container").hide(); },2000);
        });
    }
  }
}
</script>

<style>
img {
    max-width: 100%;
    height: auto;
}
.wrapper{
    border:2px solid #E8EAED;
    margin-top: 20px;
}
header{
    min-height: 190px;
    background-color: #D3EAFF;
    position: relative;
}
header img.banner-img{
    position: absolute;
    top: 0;
    right: 0;
}
header img.company-logo{
    padding-top: 40px;
    margin-left: 30px;
}
header .header-title{
    margin-left: 30px;
    font-size: 28px;
    margin-top: 35px;
}
.territory-page ul.mapping-filter{
    padding: 20px 0 20px 20px;
    list-style: none;
    margin: 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}
.territory-page ul.mapping-filter>li{
    line-height: 40px;
    margin: 0 3px 10px;
    border: 1px solid #08172B;
    border-radius: 5px;
    display: block;
    min-width: 140px;
    text-align: center;
    max-width: 150px;
}
.territory-page ul.mapping-filter li:last-child{
    margin-right: 0;
}
.territory-page .postal-code{
    background-color: #f8f8f8;
    padding: 10px;
    height: 100%;
    display: flex;
    justify-content: space-between;
}
.territory-page .postal-code input[type=text]{
    border: 0;
    border-bottom: 2px solid #707070;
    background: transparent;
    height: 48px;
    width: 100%;
}
.territory-page .postal-code .search-btn{
    background: #fff;
    border: 1px solid #08172B;
    border-radius: 34px;
    width: 150px;
    height: 60px;
}
.territory-page ul li a.active {
    background: blue;
    color: white;
}
.territory-page .multiselect__placeholder{
  margin-bottom: 0;
  padding-top: 0;
}
.territory-page .multiselect__tags{
  padding: 0 40px 0 8px;
}
.territory-page .multiselect__select{
  height: 40px;
}
.territory-page .multiselect__single{
  line-height: 40px;
  margin-bottom: 0;
  font-size: 14px;
  overflow: hidden;
  height: 40px;
}
@media(max-width:823px){
    header{
        min-height: initial;
    }
    header .header-title{
        padding-bottom: 20px;
    }
    header img.banner-img{
        width: 50%;
    }
    header img.company-logo{
        padding-top: 20px;
        margin-left: 12px;
        width: 45%;
        max-width: 200px;
    }
    .territory-page ul{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 20px 0 20px 0;
    }
    .territory-page ul li a{
        min-width: 120px;
    }
    .territory-page ul li{
        margin: 0 3px 10px;
    }
    .territory-page .postal-code input[type=text]{
        min-width: initial;
        height: 40px;
        width: 100%;
    }
    .territory-page .postal-code .search-btn{
        height: 45px;
    }
    .territory-page .row ul li .multiselect .multiselect__tags {
      padding: 2px 40px 0 8px;
    }
    .territory-page .multiselect__placeholder{margin-bottom: 0;line-height: 25px;}
    .multiselect .multiselect__tags .multiselect__placeholder {
          margin-bottom: 0px !important;
          padding-top: 0px !important;
    }

    /*.territory-page .table .table-header,.table .table-header th, .table .table-primary,.table .table-primary th,.table .table-active,.table .table-active th{
        background-color: #002B6C !important;
        border-color: #002B6C;
        color: #fff;
        font-family: 'SanFranciscoDisplayRegular';
    }*/
    .my-custom-scrollbar {
      position: relative;
      height: 200px;
      overflow: auto;
    }
    .table-wrapper-scroll-y {
      display: block;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/sales/salesoverview.vue